import { createContext, useContext, useMemo, type ReactNode } from "react";
import { api, type ApiClient } from "./client";
import { endpoints, type Endpoints } from "./endpoints";

// Lets tests swap the client for one backed by a mocked fetch, without
// module mocking.

interface ApiContextValue {
  client: ApiClient;
  endpoints: Endpoints;
}

const defaultValue: ApiContextValue = { client: api, endpoints: endpoints(api) };
const ApiContext = createContext<ApiContextValue>(defaultValue);

export function ApiProvider({ client, children }: { client?: ApiClient; children: ReactNode }) {
  const value = useMemo(() => (client ? { client, endpoints: endpoints(client) } : defaultValue), [client]);
  return <ApiContext.Provider value={value}>{children}</ApiContext.Provider>;
}

export function useApi(): ApiContextValue {
  return useContext(ApiContext);
}

export function useEndpoints(): Endpoints {
  return useContext(ApiContext).endpoints;
}
